import React, { useState, useEffect, useContext } from 'react';
import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import DialogActions from '@material-ui/core/DialogActions';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';
import { useHistory } from 'react-router-dom';
import { AppContext } from '../../../Context/AppContextProvide';
import { setUser as persistUser } from '../../../helpers';
import { completeOnboarding } from '../../../Actions';
import { startOnboardingTour } from './onboardingTour';

export default function OnboardingModal() {
  const { user, setUser, isLoggedOut, setTourMenuOpen } = useContext(AppContext);
  const [open, setOpen] = useState(false);
  const history = useHistory();

  useEffect(() => {
    if (isLoggedOut) return;
    if (!user?.user_id) return;
    if (user.access_type_cd === 'c') return;
    if (user.is_hidden) return; // internal/hidden users are never prompted with onboarding
    if (user.onboarding_completed) return;

    setOpen(true);
  }, [isLoggedOut, user?.user_id]);

  function markComplete() {
    completeOnboarding().catch(() => {});
    const updatedUser = { ...user, onboarding_completed: 1 };
    setUser(updatedUser);
    persistUser(updatedUser);
  }

  function handleSkip() {
    markComplete();
    setOpen(false);
  }

  function handleTour() {
    markComplete();
    setOpen(false);
    const isAdmin = user.access_type_cd === 'a';
    startOnboardingTour(history, isAdmin, setTourMenuOpen);
  }

  return (
    <Dialog open={open} onClose={handleSkip} maxWidth="xs" fullWidth>
      <DialogTitle disableTypography>
        <Typography variant="h6">Welcome to Showroom Pricing!</Typography>
      </DialogTitle>

      <DialogContent>
        <Typography variant="body2" color="textSecondary">
          Would you like a quick tour of the app? We'll walk you through the key areas so you can get up and running fast.
        </Typography>
      </DialogContent>

      <DialogActions style={{ justifyContent: 'space-between' }}>
        <Button onClick={handleSkip} color="default">
          Skip
        </Button>
        <Button onClick={handleTour} variant="contained" color="primary">
          Take a Tour
        </Button>
      </DialogActions>
    </Dialog>
  );
}
